import {AnimatePresence, motion} from 'framer-motion'

import type {PropsWithChildren} from 'react'

export interface AnimateOpacityProps extends PropsWithChildren {
  isVisible?: boolean
}

/**
 * Convenient component for opacity animations (for example: mouse in-out)
 *
 * Usage:
 * <AnimateOpacity isVisible={state}>
 *   <YourComponent />
 * </AnimateOpacity>
 */
export const AnimateOpacity = ({children, isVisible = false}: AnimateOpacityProps) => (
  <AnimatePresence>
    {isVisible && (
      <motion.div
        initial={{opacity: 0}}
        animate={{opacity: 1}}
        exit={{opacity: 0}}
      >
        {children}
      </motion.div>
    )}
  </AnimatePresence>
)
